import { Card, FormField, FormFieldRow, Heading, ReadOnlyField } from '@msaf/core-react'
import { CasingFieldsView } from '../../../../types/form-types'

interface WellConstructionCasingsViewInterface {
  fields: Partial<CasingFieldsView>
  index: number
  isLoading: boolean
}

export default function WellConstructionCasingsView({
  fields,
  index,
  isLoading,
}: WellConstructionCasingsViewInterface) {
  return (
    <Card>
      <Heading isSkeleton={isLoading} level={4}>
        {`Casing ${index + 1}`}
      </Heading>

      <FormField isSkeleton={isLoading} label='Type' labelId='casingMaterialLabel'>
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='casingMaterialLabel'
          value={`${fields['casingMaterial'] ?? ''}`}
        />
      </FormField>

      <FormFieldRow>
        <FormField isSkeleton={isLoading} label='Top(m)' labelId='casingTopLabel'>
          <ReadOnlyField isSkeleton={isLoading} labelledBy='casingTopLabel' value={`${fields['casingTop'] ?? ''}`} />
        </FormField>
        <FormField isSkeleton={isLoading} label='Bottom(m)' labelId='casingBottomLabel'>
          <ReadOnlyField
            isSkeleton={isLoading}
            labelledBy='casingBottomLabel'
            value={`${fields['casingBottom'] ?? ''}`}
          />
        </FormField>
      </FormFieldRow>

      <FormFieldRow>
        <FormField isSkeleton={isLoading} label='Casing inside diameter(mm)' labelId='casingsInsideDiameterLabel'>
          <ReadOnlyField
            isSkeleton={isLoading}
            labelledBy='casingInsideDiameterLabel'
            value={`${fields['casingInsideDiameter'] ?? ''}`}
          />
        </FormField>
        <FormField isSkeleton={isLoading} label='Casing thickness(mm)' labelId='casingThicknessLabel'>
          <ReadOnlyField
            isSkeleton={isLoading}
            labelledBy='casingThicknessLabel'
            value={`${fields['casingThickness'] ?? ''}`}
          />
        </FormField>
      </FormFieldRow>
    </Card>
  )
}
